import { render, staticRenderFns } from "./BaseIconSvg.vue?vue&type=template&id=141e67c4&scoped=true&"
import script from "./BaseIconSvg.vue?vue&type=script&lang=js&"
export * from "./BaseIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141e67c4",
  null
  
)

export default component.exports